import Vue from 'vue'
import Vuex from 'vuex'

import logInsepct from './modules/logInspect'
import licensor from './modules/licensor'
import albumInfo from './modules/albumInfo'
import artistInfo from './modules/artistInfo'
import trackInfo from './modules/trackInfo'
import ownerList from './modules/ownerList'
import salesLine from './modules/salesLine'
import musicStore from './modules/musicstore'
import settlement from './modules/settlement'
import transfer from './modules/transfer'
import calendar from './modules/calendar'
import ddex from './modules/ddex'
import advancepayment from './modules/advancepayment'
import support from './modules/support'
import exportPreset from './modules/exportPreset'

import login from './modules/login'
import withdrawal from './modules/withdrawal'
import payment from './modules/payment'

import { country, dialing , bank } from './data.js'
import {navbarSearchAndPinList} from "@/renew/layouts/components/navbarMenu"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "John Doe", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  status      : "online",
  userRole    : "admin"
}
const is_touch_device = () => {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
      return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
      return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}
const STRICT_MODE = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)
const theme = localStorage.getItem('srTheme');
let storageBookmark =  localStorage.getItem('srd_bookmark');
if(storageBookmark){
  storageBookmark = JSON.parse(storageBookmark)
  for(var j in storageBookmark){
    for(var i in navbarSearchAndPinList.pages.data){
      if(storageBookmark[j].url == navbarSearchAndPinList.pages.data[i].url){
        navbarSearchAndPinList.pages.data[i] = storageBookmark[j]
      }

    }
  }
}
let ddd = localStorage.getItem("userInfo") 
ddd= JSON.parse(ddd)

const state = {
  AppActiveUser           : ddd,
  bodyOverlay             : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || "vertical",
  navbarSearchAndPinList  : navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : "default",
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
  theme                   : theme? theme : "dark",
  themePrimaryColor       : colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  modalCount: 0,

}

const mutations = {
  MUTATE_MODAL_COUNT (state, count) {
    state.modalCount = state.modalCount + count < 0 ? 0 : state.modalCount + count
  },
  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
      localStorage.setItem('srd_bookmark',JSON.stringify(state.starredPages))
    }
    else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
      localStorage.setItem('srd_bookmark',JSON.stringify(state.starredPages))
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp                 = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay       = val   },
  UPDATE_PRIMARY_COLOR(state, val)   { state.themePrimaryColor = val   },
  UPDATE_THEME(state, val)           { localStorage.setItem('srTheme',val); state.theme             = val   },
  UPDATE_WINDOW_WIDTH(state, width)  { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY           = val   },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {

    // Get Data localStorage
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser
    // Store data in localStorage
    state.AppActiveUser = userInfo
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
}

const actions = {
  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  variationModalCount ({ commit }, count) {
    commit('MUTATE_MODAL_COUNT', count)
  },
  windowBackPrevent({commit}, payload){window.innerDoc=false;window.addEventListener('mouseover', function(event) {window.innerDoc = true});window.addEventListener('mouseout', function(event) {window.innerDoc = false});history.pushState({page: payload}, document.title, location.pathname);switch(payload){case'RegistAlbum':case'RegistAlbumFromFile':return;default:window.onpopstate = function(){history.pushState({page: payload}, document.title, location.pathname);if(!window.innerDoc) location.reload()};break;}},
  TOKEN_ITEM_CLEAR({commit}){
    localStorage.removeItem('srAccessToken')
  }
}

export default new Vuex.Store({
  strict: STRICT_MODE,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: {
    windowBreakPoint: state => {

      // This should be same as tailwind. So, it stays in sync with tailwind utility classes
      if (state.windowWidth >= 1200) return "xl"
      else if (state.windowWidth >= 992) return "lg"
      else if (state.windowWidth >= 768) return "md"
      else if (state.windowWidth >= 576) return "sm"
      else return "xs"
    },
  
    scrollbarTag: state => {
      return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
    }
  },
  modules: {
    logInsepct,
    licensor,
    albumInfo,
    artistInfo,
    trackInfo,
    ownerList,
    login,
    withdrawal,
    payment,
    salesLine,
    musicStore,
    settlement, //정산세계발행
    transfer, // 내부이관 
    advancepayment, // 선급금계약
    ddex,// ddex
    calendar,
    support, // 고객센터
    exportPreset,
  },
})
